import { Box, StepLabel, styled } from "@mui/material";
import StepConnector from "@mui/material/StepConnector";
import Step from "@mui/material/Step";

export const Connector = styled(StepConnector)({
    "&.MuiStepConnector-root": {
        top: "50%",
        transform: "translateY(-50%) ",
        width: "30px",
        left: "-15px",
    },
    "& .MuiStepConnector-line": {
        borderColor: "#dcdcdc",
        borderTopWidth: 3,
    },
});

export const StepIconRoot = styled(Box)({
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: "17px",
    height: "17px",
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
});

export const ArrowStepIconRoot = styled(Box)({
    backgroundColor: "transparent",
    zIndex: 1,
    color: "#dcdcdc",
    width: "17px",
    height: "17px",
    svg: {
        width: "12px",
        height: "12px",
    },
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
});

export const CustomStepLabel = styled(StepLabel)({
    "& .MuiStepLabel-labelContainer": {
        padding: "0px",
    },
});

export const CustomStep = styled(Step)({
    "&.MuiStep-root": {
        padding: "0 4px",
    },
});
